import axios from 'axios';

import { storeDetailVApolling } from './constants';
import { getSecureBaseUrl } from '../../../services/UrlMapperService';

export const showVideoChatAssistFlag = (data) => ({
  type: 'SHOW_VIDEO_CHAT_ASSIST',
  data,
});

export const showVideoChatAssisAct = (getMediaURL, sessionId, zipCode, isRepAvailable, pollCount) => ({
  type: 'SHOW_VIDEO_CHAT_ASSIST_ACT',
  getMediaURL,
  sessionId,
  zipCode,
  isRepAvailable,
  pollCount,
});

/* This method used to set the flag for displaying the Video Chat icon based on pollcount and status from api reponse */
export function showVideoChatAssistAction(getMediaURL, sessionId, zipCode, isRepAvailable, pollCount = 0, errorTimer = 0, errorCount = 1) {
  const { pollingTimer, maxPollCount } = storeDetailVApolling;
  let pc = pollCount;

  if (pc <= maxPollCount) {
    if (pc === 1) {
      // Trigger at initial to get availablity
      pc += 1;
      this.checkVideoAssist(sessionId, zipCode, pc, errorCount, isRepAvailable, getMediaURL);
    } else {
      pc += 1;
      setTimeout(() => {
        this.checkVideoAssist(sessionId, zipCode, pc, errorCount, isRepAvailable, getMediaURL);
      }, (pollingTimer + errorTimer) * 1000);
    }
  }
}

/* Method to make a call api with request and headers and check if rep is available */
export const checkVideoAssist = (sessionId, zipCode) => () => {

  const videoAssistUrl = `${getSecureBaseUrl(true)}/mediaservice/getmediastats`;

  const data = {
    transid: null,
    uId: sessionId,
    mediainput: {
      searchdepth: 1,
      geotype: '2',
      geovalue: zipCode,
    },
  };
  const headers = {
    channelId: 'VZW-DOTCOM',
    sourceChannelName: '5g-home',
    includeCookies: true,
  };

  return axios.post(videoAssistUrl, data, {
    headers,
  }).catch((ex) => {
    console.log('Error in VideoAssist api', ex);
  });
  };
  
/* method to check if the rep is avaliable based on the api response */
export const getAvailableRepFlag = (res) => {
  const response = res && res.data;
  if (response) {
    if (Object.prototype.hasOwnProperty.call(response, 'mediaoutput')) {
      if (response && response.mediaoutput && response.mediaoutput.agentAvailabilityResponse === 'true') {
        return true;
      }
      return false;
    }
    return 'error';
  }
};
